module.exports = __webpack_public_path__ + "img/column.6a029650.svg";